// 「문의하기」 진입점 노출 훅 — src/lib/supportInquiryOpen.js 의 React 포장 (2026-10-23)
//
//   const { visible, loading } = useSupportInquiryVisible(userInfo?.role);
//   · visible : 문의하기 메뉴·링크를 그려도 되는가 (11/1 이후 · 기존 스위치 켜짐 · 어드민 미리보기). 읽는 중에는 false.
import { useEffect, useState } from "react";
import { fetchSupportInquiryOpen, getSupportInquiryOpenCache, resolveSupportVisible } from "../lib/supportInquiryOpen";

export default function useSupportInquiryVisible(role) {
  const [state, setState] = useState(() => {
    const c = getSupportInquiryOpenCache();
    return c ? { loading: false, open: c.open } : { loading: true, open: false };
  });
  useEffect(() => {
    let alive = true;
    fetchSupportInquiryOpen().then((c) => { if (alive) setState({ loading: false, open: c.open }); });
    return () => { alive = false; };
  }, []);
  return { ...state, visible: resolveSupportVisible({ open: state.open, role }) };
}
